import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "accountClosingForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VTextField, {
                attrs: { label: "ID", required: true },
                model: {
                  value: _vm.accountClosing.id,
                  callback: function ($$v) {
                    _vm.$set(_vm.accountClosing, "id", $$v)
                  },
                  expression: "accountClosing.id",
                },
              }),
              _c("date-picker", {
                attrs: {
                  label: "Closed Date",
                  "show-hint": false,
                  "show-icon": false,
                },
                model: {
                  value: _vm.accountClosing.closingDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.accountClosing, "closingDate", $$v)
                  },
                  expression: "accountClosing.closingDate",
                },
              }),
              _c(VTextField, {
                attrs: { label: "By User", required: true },
                model: {
                  value: _vm.accountClosing.adminUserId,
                  callback: function ($$v) {
                    _vm.$set(_vm.accountClosing, "adminUserId", $$v)
                  },
                  expression: "accountClosing.adminUserId",
                },
              }),
              _c("date-picker", {
                attrs: {
                  label: "Created On",
                  "show-hint": false,
                  "show-icon": false,
                },
                model: {
                  value: _vm.accountClosing.recordedTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.accountClosing, "recordedTime", $$v)
                  },
                  expression: "accountClosing.recordedTime",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }